import React from "react";
import { Modal, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";

//components
import Button from '../../../../components/CustomButton/CustomButton'

//Assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg'

const GeneratedCyclesPreviewModal = ({ show, onHide, cycles, t, dateFormat }) => {
    if (!cycles) return null;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header>
                <Modal.Title>{t('All Generated Cycles')}</Modal.Title>
                <img src={CloseModalIcon} className="cursor-pointer" alt='close icon' onClick={onHide} />
            </Modal.Header>
            <Modal.Body className="p-0">
                <div className="table-scroll">
                    <Table hover responsive className="mb-0 align-middle">
                        <thead className="table-light">
                            <tr>
                                <th className="text-secondary fw-semibold ps-3">{t('Cycles')}</th>
                                <th className="text-secondary fw-semibold text-center">{t('Status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cycles.map((c, i) => (
                                <tr key={i}>
                                    <td className="fw-bold ps-3 text-primary-color">
                                        {moment(c.start).format(dateFormat)} &rarr; {moment(c.end).format(dateFormat)}
                                    </td>
                                    <td className="text-center">
                                        {c.is_merged ? (
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-shared-${i}`}>
                                                        {t('This cycle contains multiple work patterns')}
                                                    </Tooltip>
                                                }
                                            >
                                                <span className="cursor-pointer text-primary-color">
                                                    {t('Shared')}
                                                </span>
                                            </OverlayTrigger>
                                        ) : (
                                            <span className="text-muted fw-bold">-</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('Close')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default GeneratedCyclesPreviewModal;